import { render } from "./DeleteCommunicationDialog.vue?vue&type=template&id=223f7a98&scoped=true&ts=true&lang=pug"
import script from "./DeleteCommunicationDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteCommunicationDialog.vue?vue&type=script&lang=ts"

import "./DeleteCommunicationDialog.vue?vue&type=style&index=0&id=223f7a98&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223f7a98"]])

export default __exports__